import { render, staticRenderFns } from "./dataManage.vue?vue&type=template&id=19123b1e&"
import script from "./dataManage.vue?vue&type=script&lang=js&"
export * from "./dataManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports